/* AFERIY Recommended Product Total | 2026-10-19
 * Prices are integer minor units from Shopify Liquid JSON, not parsed from visible currency strings.
 * Standalone: does not modify product gallery, variant picker or cart submission.
 */
(()=>{
  'use strict';
  const controllers=new WeakMap();
  const num=v=>Number.isFinite(Number(v))?Math.max(0,Math.round(Number(v))):0;
  const qty=v=>Math.max(1,Math.min(999,parseInt(v,10)||1));
  const parseJSON=node=>{try{return JSON.parse(node?.textContent||'[]')}catch(err){console.warn('[AF Recommended] Invalid variant data',err);return []}};
  const classSelected=el=>/(?:^|\s)(?:act|active|selected|checked|is-checked|is-selected|Recommended_product_item_input_div_act)(?:\s|$)/i.test(el?.className||'');
  const wasSelected=el=>{
    if(!el)return false;
    if(el.dataset.afSelected!==undefined)return el.dataset.afSelected==='true';
    if(classSelected(el)||classSelected(el.parentElement))return true;
    const svg=el.querySelector('svg');
    if(!svg)return false;
    const s=getComputedStyle(svg),p=svg.querySelector('path'),ps=p?getComputedStyle(p):null;
    return s.display!=='none'&&s.visibility!=='hidden'&&Number(s.opacity)>0.1&&(!ps||(ps.display!=='none'&&ps.visibility!=='hidden'&&Number(ps.opacity)>0.1));
  };
  const money=(cents,currency)=>{
    if(window.Shopify&&typeof window.Shopify.formatMoney==='function'&&window.money_format){
      try{const div=document.createElement('div');div.innerHTML=window.Shopify.formatMoney(cents,window.money_format);const result=div.textContent.trim();if(result)return result}catch(e){}
    }
    try{return new Intl.NumberFormat('es-ES',{style:'currency',currency:currency||'EUR'}).format(cents/100)}catch(e){return `€${(cents/100).toFixed(2)}`}
  };
  function init(section){
    if(!section||controllers.has(section))return;
    const panels=[...section.querySelectorAll('.Recommended_product[data-af-recommended]')];
    if(!panels.length)return;
    const panel=panels[0],pid=panel.dataset.afMainProduct;
    const variants=parseJSON(panel.querySelector('[data-af-main-variants]'));
    const form=section.querySelector(`form[id="product-form-${pid}"]`);
    const variantInput=form?.querySelector('input[name="id"]');
    const subtotal=section.querySelector('.New_Checkout_module .Subtotal_Price_dprice');
    if(!variants.length||!subtotal)return;
    const originalTotal=section.querySelector('.New_Checkout_module .Subtotal_Price_yprice');
    const savings=section.querySelector('.New_Checkout_module .Subtotal_Price_label');
    const currency=panel.dataset.afCurrency||'EUR';
    const cards=panels.flatMap(p=>[...p.querySelectorAll('[data-af-addon-card]')]);
    const addonMeta=new Map();
    for(const card of cards){
      const options=parseJSON(card.querySelector('[data-af-addon-variants]')).filter(v=>v&&v.available!==false);
      const tick=card.querySelector('.Recommended_product_item_input_div');
      if(!options.length||!tick)continue;
      addonMeta.set(card,options);
      const first=options.find(v=>String(v.id)===String(tick.dataset.id))||options.find(v=>v.available)||options[0];
      card.dataset.afVariantId=String(first.id);
      const checked=wasSelected(tick);
      tick.dataset.afSelected=String(checked);
      tick.setAttribute('role','checkbox');tick.setAttribute('aria-checked',String(checked));tick.setAttribute('tabindex','0');
    }
    const format=cents=>money(cents,currency);
    const getMain=()=>{
      const id=variantInput?.value||section.querySelector(`variant-radios[data-product="${pid}"],variant-selects[data-product="${pid}"]`)?.currentVariant?.id;
      return variants.find(v=>String(v.id)===String(id))||variants.find(v=>v.available)||variants[0];
    };
    const mainQuantity=()=>{
      const input=form?.querySelector('input[name="quantity"]')||section.querySelector('.quantity__group--1 input.quantity__input')||section.querySelector('.quantity_selector input[name="quantity"]');
      return qty(input?.value);
    };
    const optionFor=card=>{
      const list=addonMeta.get(card)||[];
      const id=card.dataset.afVariantId||card.querySelector('.Recommended_product_item_input_div')?.dataset.id;
      return list.find(v=>String(v.id)===String(id))||list[0];
    };
    function refreshCard(card){
      const variant=optionFor(card);if(!variant)return;
      const current=num(variant.price),compare=num(variant.compare_at_price),hasCompare=compare>current;
      const el=card.querySelector('.Recommended_product_item_text_centent_yprict');
      const old=card.querySelector('.Recommended_product_item_text_centent_cprict');
      const saving=card.querySelector('.Recommended_product_item_text_centent_save');
      if(el&&el.textContent.trim()!==format(current))el.textContent=format(current);
      if(old){old.hidden=!hasCompare;if(hasCompare)old.textContent=format(compare)}
      if(saving){saving.hidden=!hasCompare;if(hasCompare)saving.textContent=`-${Math.round((compare-current)*100/compare)}%`}
    }
    function compute(){
      const main=getMain(),count=mainQuantity(),price=num(main?.price),comp=num(main?.compare_at_price);
      let total=price*count,compareTotal=Math.max(price,comp)*count,selectedCount=0,extraTotal=0;
      for(const card of cards){
        const box=card.querySelector('.Recommended_product_item_input_div');
        if(!box||box.dataset.afSelected!=='true')continue;
        const variant=optionFor(card);if(!variant)continue;
        const quantity=qty(card.querySelector('input.input_quantity_int')?.value);
        const unit=num(variant.price),was=num(variant.compare_at_price);
        extraTotal+=unit*quantity;total+=unit*quantity;compareTotal+=Math.max(unit,was)*quantity;selectedCount+=quantity;
      }
      return {total,compareTotal,saved:Math.max(0,compareTotal-total),base:price*count,extraTotal,selectedCount};
    }
    function render(){
      for(const card of cards)refreshCard(card);
      const t=compute();
      const final=format(t.total);
      if(subtotal.textContent.trim()!==final)subtotal.textContent=final;
      if(originalTotal){
        const visible=t.saved>0;
        originalTotal.hidden=!visible;
        if(visible&&originalTotal.textContent.trim()!==format(t.compareTotal))originalTotal.textContent=format(t.compareTotal);
      }
      if(savings){
        const visible=t.saved>0;
        savings.hidden=!visible;
        const label=`${format(t.saved)} off`;
        if(visible&&savings.textContent.trim()!==label)savings.textContent=label;
      }
      section.dataset.afTotalCents=String(t.total);
      section.dataset.afSelectedExtras=String(t.selectedCount);
      return t;
    }
    let queued=false;
    function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;render()})}
    panels.forEach(p=>{
      p.addEventListener('click',e=>{
        const check=e.target.closest('.Recommended_product_item_input_div');
        if(check&&p.contains(check)){
          const next=check.dataset.afSelected!=='true';
          check.dataset.afSelected=String(next);check.setAttribute('aria-checked',String(next));schedule();return;
        }
        const chosen=e.target.closest('.product_item_option_select_item');
        if(chosen&&p.contains(chosen)){
          const card=chosen.closest('[data-af-addon-card]');
          const id=chosen.dataset.id;
          if(card&&id&&addonMeta.get(card)?.some(v=>String(v.id)===String(id))){
            card.dataset.afVariantId=id;
            const checkEl=card.querySelector('.Recommended_product_item_input_div');
            const qtyEl=card.querySelector('input.input_quantity_int');
            if(checkEl)checkEl.dataset.id=id;
            if(qtyEl)qtyEl.dataset.id=id;
          }
          schedule();return;
        }
        if(e.target.closest('.plus_quantity,.minus_quantity'))schedule();
      },true);
      p.addEventListener('keydown',e=>{
        if((e.key===' '||e.key==='Enter')&&e.target.matches('.Recommended_product_item_input_div')){
          e.preventDefault();e.target.click();
        }
      });
      p.addEventListener('change',schedule,true);
      p.addEventListener('input',schedule,true);
    });
    section.addEventListener('change',e=>{if(e.target.matches('input[name="id"],input[name="quantity"],input.quantity__input,select'))schedule()},true);
    section.addEventListener('input',e=>{if(e.target.matches('input[name="quantity"],input.quantity__input'))schedule()},true);
    section.addEventListener('click',e=>{
      if(e.target.closest('quantity-input button,.get_quantity_int,.btn-quantity'))schedule();
    },true);
    const watch=new MutationObserver(schedule);
    watch.observe(subtotal,{childList:true,subtree:true,characterData:true});
    controllers.set(section,{refresh:render,compute,disconnect:()=>watch.disconnect()});
    render();
  }
  function initAll(){document.querySelectorAll('[id^="ProductSection-"]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});else initAll();
  document.addEventListener('shopify:section:load',e=>{const sec=e.target.querySelector('[id^="ProductSection-"]');if(sec)init(sec)});
  window.AFRecommendedTotal={refresh:()=>{initAll();document.querySelectorAll('[id^="ProductSection-"]').forEach(el=>controllers.get(el)?.refresh())},getTotal:sectionId=>{const node=document.getElementById(sectionId);return node&&controllers.get(node)?.compute()}};
})();
